import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { QuizzesDataService, QuizzesColumnsService } from '../../../services';
import { Quiz, QuizzesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-quiz-details',
  templateUrl: './quiz-details.component.html',
  styleUrls: ['./quiz-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class QuizDetailsComponent implements OnInit, OnDestroy {

  public quiz: Quiz = {};
  public quizzes: Quiz[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private quizzesDataService: QuizzesDataService,
    private quizzesColumnsService: QuizzesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Quiz - Details');
        this.getQuiz(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.quiz !== 'undefined') {
      this.quiz = this.dynamicDialogConfig.data.quiz;
    }
    this.columns = this.quizzesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getQuiz(id: number): void {
    this.isLoading = true;
    this.quizzesDataService.getQuiz(id).subscribe((response: Quiz|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.quiz = response;
      }
    });
  }

  list() {
    this.router.navigate(['/quizzes']);
  }

  add() {
    this.router.navigate(['/quizzes/add']);
  }

  edit() {
    this.router.navigate(['/quizzes/edit/' + this.quiz.id]);
  }

}
@Component({
  selector: 'app-quiz-details',
  templateUrl: './quiz-details.component.html',
  styleUrls: ['./quiz-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogQuizDetailsComponent extends QuizDetailsComponent {
}

